/** Altura fixa do canvas (px) — `maintainAspectRatio: false` para o radar usar bem o cartão. */
export const RADAR_CHART_HEIGHT = 420;

/** Opções visuais partilhadas pelos radares de desempenho. */
export const radarChartLayoutOptions = {
  maintainAspectRatio: false,
  scale: {
    ticks: {
      beginAtZero: true,
      min: 0,
      max: 10,
      stepSize: 5,
      fontSize: 11,
      fontColor: "#555"
    },
    pointLabels: {
      fontSize: 12,
      fontColor: "#444",
      fontFamily: "'Arial', 'Helvetica', 'Helvetica Neue', sans-serif"
    }
  },
  legend: {
    display: true,
    position: "bottom",
    labels: {
      usePointStyle: true,
      fontColor: "#444",
      fontStyle: "bold",
      fontSize: 14,
      boxWidth: 8,
      fontFamily: "'Arial', 'Helvetica', 'Helvetica Neue', 'sans-serif'",
      padding: 28
    }
  }
};
